import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import { toggleBackButtonAction } from '../../../reactRedux/Actions/sideBarAction';
import classNames from 'classnames';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import styles from './styles.module.scss';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import { remove_token } from '../../../helpers/api';
import { logoutAction } from '../../../reactRedux/mainAction';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import {
  useGetUserSetting,
  useUpdateUserSetting
} from '../../../hooks/httpRequests';
import { useApplyLanguage } from '../../../i18n/LanguageSync';
import { queryKeys } from '../../../react-query/constant';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Settings = () => {
  const { t, language } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const history = useHistory();
  const queryClient = useQueryClient();
  const applyLanguage = useApplyLanguage();

  const { data: userSetting } = useGetUserSetting();
  const updateUserSetting = useUpdateUserSetting();

  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));
  const setSideBarBackButton = (show) => dispatch(toggleBackButtonAction(show));
  const logout = () => dispatch(logoutAction());

  useEffect(() => {
    setSideBarBackButton(true);

    return () => setSideBarBackButton(false);
  }, []);

  useEffect(() => {
    setHeader(t('settings.title'));
    setHeaderConfigs({ credits: false, exit: false, back: true });
  });

  const exitFn = () => {
    remove_token();
    logout();
    history.push(routes.LOGIN);
  };

  const changeLanguage = (event, next) => {
    if (!next || next === language) return;
    updateUserSetting.mutate(
      { data: { language: next } },
      {
        onSuccess({ data }) {
          applyLanguage(data?.language || next);
        },
        onError(err) {
          // 400: the bilingual feature was turned off meanwhile
          if (err.response?.status === 400) {
            queryClient.invalidateQueries(['organizationFeatures']);
            queryClient.invalidateQueries([queryKeys.organization_features]);
            queryClient.invalidateQueries([queryKeys.user_setting]);
            applyLanguage('fa');
          }
        }
      }
    );
  };

  const languageRow = () => (
    <div className={classNames(styles.listRow, styles.noAction)}>
      <TranslateRoundedIcon />
      <div className={styles.title}>{t('settings.language')}</div>
      <ToggleButtonGroup
        className={styles.language}
        value={language}
        exclusive
        size="small"
        color="primary"
        disabled={updateUserSetting.isLoading}
        onChange={changeLanguage}
      >
        <ToggleButton value="fa">فارسی</ToggleButton>
        <ToggleButton value="en">English</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );

  const listRow = (title, icon, isExit, action) => {
    const Icon = icon;

    return (
      <div
        className={classNames(styles.listRow, { [styles.exit]: isExit })}
        onClick={action}
      >
        <Icon />
        <div className={styles.title}>{title}</div>
      </div>
    );
  };

  return (
    <div className={classNames(styles.page, styles.full)}>
      {isDesktop && (
        <div className={styles.pageHeader}>{t('settings.title')}</div>
      )}
      <div className={styles.section}>
        <div className={styles.sectionBody}>
          {listRow(t('settings.notifications'), NotificationsIcon, false, () =>
            history.push(routes.SETTINGS_NOTIFICATIONS)
          )}
          {userSetting?.can_choose_language && languageRow()}
          {listRow(t('settings.changePassword'), VpnKeyIcon, false, () =>
            history.push(routes.CHANGE_PASS)
          )}
          {listRow(
            t('settings.privacy'),
            AdminPanelSettingsOutlinedIcon,
            false,
            () => (window.location.href = 'https://o2reco.ir/tc/')
          )}
          {listRow(t('common.exit'), ExitToAppRoundedIcon, true, exitFn)}
        </div>
      </div>
    </div>
  );
};

export default Settings;
